import { List } from 'immutable';

import { entityState } from './entity/actionsAndReducer';
import { errorState } from './errors/actionsAndReducer';
import { sessionState } from './session/actionsAndReducer';
import { userState } from './users/actionsAndReducer';
import {claimsState} from "./claims/actionsAndReducer";

export const state = List([entityState, errorState, sessionState, userState, claimsState]);

